// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2iKm3","footer":"ModalError_footer__2VpWG"};